"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersTableCols = void 0;
exports.usersTableCols = [
    {
        name: "Timestamp",
        id: "timestamp",
        type: "datetime",
        internal: 't."timestamp"',
    },
    {
        name: "User ID",
        id: "userId",
        type: "stringOptions",
        options: [],
        internal: 'u."id"',
    },
];
